var firebaseConfig = {
  apiKey: "AIzaSyBP6WHRAiPpk5XlB-rp3rnCV-Wwoxy9IUE",
  authDomain: "pandoconnect-c9991.firebaseapp.com",
  databaseURL: "https://pandoconnect-c9991.firebaseio.com",
  projectId: "pandoconnect-c9991",
  storageBucket: "pandoconnect-c9991.appspot.com",
  messagingSenderId: "780635904490",
  appId: "1:780635904490:web:4b0335650d7f5d4cd53a93",
  measurementId: "G-55S7179XXY",
};

export default firebaseConfig;
